export default (state = [], action) => {
	switch (action.type) {
		case "ADD_PRICELIST":
			var newState = state.slice();
			newState.push(action.pricelist);
			return newState;
		default:
			return state;
	}
};
